class ContentMask {
  /* ========================================================================
   * Masking of some content relative to rgpd / user status
   * ======================================================================== */

  constructor() {}

  /* ========================================================================
   * Didomi / RGPS Masking
   * ======================================================================== */
  async addMaskOnPartners(){
    /* Remplacement des iframe partenaires pour prise en compte masque RGPD */
    /* Youtube */
    [... document.querySelectorAll('iframe[src*="www.youtube.com"]')].map( iframeEl => {
      iframeEl.classList.add( 'contentmask-maskeditem' );
      iframeEl.dataset.rgpdsrc = iframeEl.getAttribute('src');
      iframeEl.removeAttribute('src');
      iframeEl.dataset.masktitle = "Vous devez accepter l'utilisation des cookies de Youtube pour lire la vidéo";
      iframeEl.dataset.rgpdvendormask = "c:youtube";
    });
    /* Dailymotion */
    [... document.querySelectorAll('script[src*="www.dailymotion.com"]')].map( iframeEl => {
      iframeEl.classList.add( 'contentmask-maskeditem' );
      iframeEl.dataset.rgpdsrc = iframeEl.getAttribute('src');
      iframeEl.removeAttribute('src');
      iframeEl.dataset.masktitle = "Vous devez accepter l'utilisation des cookies de Dailymotion pour lire la vidéo";
      iframeEl.dataset.rgpdvendormask = "573";
    });
    /* Digiteka */
    [... document.querySelectorAll('iframe[src*="www.ultimedia.com"], .digitekaplaceholder')].map( iframeEl => {
      iframeEl.classList.add( 'contentmask-maskeditem' );
      if( iframeEl.getAttribute('src') && typeof iframeEl.getAttribute('src') !== undefined ){
        iframeEl.dataset.rgpdsrc = iframeEl.getAttribute('src');
        iframeEl.removeAttribute('src');
      }
      iframeEl.dataset.masktitle ="Vous devez accepter l'utilisation des cookies de Digiteka pour lire la vidéo";
      iframeEl.dataset.rgpdvendormask = "343";
    });
    /* taboola */
    [... document.querySelectorAll('.taboola')].map( iframeEl => {
      iframeEl.classList.add( 'contentmask-maskeditem' );
      iframeEl.dataset.masktitle = "Vous devez accepter l'utilisation des cookies de Taboola pour voir la liste des contenus conseillés";
      iframeEl.dataset.rgpdvendormask = "42";
      iframeEl.dataset.rgpdpurposemask = "use_limited_data_to_select_content";
    });
  }

  async updateRGPDVendorMasks(){
    [... document.querySelectorAll('[data-rgpdvendormask]')].map( el => {
      let vendorid =  !isNaN( el.dataset.rgpdvendormask )? Number.parseInt( el.dataset.rgpdvendormask ) : el.dataset.rgpdvendormask;
      let purposeid =  !isNaN( el.dataset.rgpdvendormask )? el.dataset.rgpdpurposemask : null;
      
      let consentStatus = Didomi.getUserConsentStatusForVendor( String( vendorid ) );

      let consentPurposeStatus = true;
      if(purposeid){
        consentPurposeStatus = Didomi.getUserConsentStatusForPurpose(el.dataset.rgpdpurposemask);
      }

      if( consentPurposeStatus == false || ( typeof consentStatus === undefined || consentStatus !== true ) && !el.parentNode.classList.contains('contentmask-container') ) {
        let masktitle = ( typeof el.dataset.masktitle !== undefined && el.dataset.masktitle )? el.dataset.masktitle : 'Pour accèder à cette fonctionnalité, vous devez autoriser notre partenaire à déposer des cookies';
        let maskbutton = ( typeof el.dataset.maskbutton !== undefined && el.dataset.maskbutton )? el.dataset.maskbutton : 'Je modifie le paramétrage de mes cookies';
        let maskHTML = '<div class="contentmask"><div class="contentmask-inner">' + masktitle + '<button class="btn btn-primary btn-mask">' + maskbutton + '</button>' + '</div></div>';
        el.classList.add( 'contentmask-maskeditem' );

        let wrapper = document.createElement('div');
        wrapper.classList.add( 'contentmask-container' );
        wrapper.classList.add( 'embed-responsive-item' );
       
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);

        wrapper.innerHTML += maskHTML;

        wrapper.querySelector('.btn-mask').addEventListener( 'click', (e) => {
          Didomi.notice.show();
        });
      }
      else if( typeof consentStatus !== undefined && consentStatus === true ){
        el.classList.remove( 'contentmask-maskeditem' );
        if( typeof el.dataset.rgpdsrc !== undefined && el.dataset.rgpdsrc !== false){
          el.setAttribute('src', el.dataset.rgpdsrc ); // iframe avec data-rgpdsrc -> on modifie en src
          el.removeAttribute('data-rgpdsrc');
        }
        if( el.parentNode.classList.contains('contentmask-container') ){
          if( el.parentNode.querySelector('.contentmask') ){
            el.parentNode.querySelector('.contentmask').remove();
          }
          el.parentNode.replaceWith( el );
        }
      }
    });
  }

  async addConsentNoticeHandler(){
    let Contentmask = this;
    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push(function () {
      Contentmask.updateRGPDVendorMasks();
    });

    window.didomiEventListeners = window.didomiEventListeners || [];
    window.didomiEventListeners.push({
      event: 'consent.changed',
      listener: function () {
        Contentmask.updateRGPDVendorMasks();
      }
    });
  }

  /* ========================================================================
    * User status Masking : use user dataLayer boolean variable :
    * Usable : loggedin / abonne_news / abonne_print / abonne_news_or_print
    * ======================================================================== */
  async addMaskForUserstatus(){
    [... document.querySelectorAll('[data-userstatusmask]')].map( el => {
      let statusneedeed =  el.dataset.userstatusmask;
      let userStatus = ( typeof dataLayer !== undefined && typeof dataLayer[0] !== undefined && typeof dataLayer[0].user !== undefined && typeof dataLayer[0].user[statusneedeed] !== undefined )? dataLayer[0].user[statusneedeed] : false;
      if (userStatus !== true && !el.parentNode.classList.contains('contentmask-container') ) {
        let masktitle = ( typeof el.dataset.masktitle !== undefined && el.dataset.masktitle !== false)? el.dataset.masktitle : 'Vous devez être connecté(e) pour accéder à cette fonctionnalité.';
        let maskbutton = ( typeof el.dataset.maskbutton !== undefined && el.dataset.maskbutton !== false)? el.dataset.maskbutton : 'Se connecter / S\'inscrire';
        let maskbuttonurl = ( typeof el.dataset.maskbuttonurl !== undefined && el.dataset.maskbuttonurl !== false)? el.dataset.maskbuttonurl : false;
        let maskHTML = '<div class="contentmask"><div class="contentmask-inner">' + masktitle + ( maskbuttonurl? '<a href="'+maskbuttonurl+'" class="btn btn-primary btn-mask">'+maskbutton+'</a>' : (el.dataset.maskorigin?'<span data-origin="'+el.dataset.maskorigin+'">' : '')+'<button class="btn btn-primary btn-mask login-link">'+maskbutton+'</button>' ) +(el.dataset.maskorigin?'</span>' : '')+ '</div></div>';

        el.classList.add( 'contentmask-maskeditem' );

        let wrapper = document.createElement('div');
        wrapper.classList.add( 'contentmask-container' );
        wrapper.classList.add( 'embed-responsive-item' );

        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);

        wrapper.innerHTML += maskHTML;
      }
      else if ( userStatus === true ){
        el.classList.remove( 'contentmask-maskeditem' );
        if( el.parentNode.classList.contains('contentmask-container') ){
          if( el.parentNode.querySelector( '.contentmask' ) ){
            el.parentNode.querySelector( '.contentmask' ).remove();
          }
          el.parentNode.replaceWith( el );
        }
      }
    });
  }

  async init(){
    this.addMaskOnPartners();
    this.addMaskForUserstatus();
    this.addConsentNoticeHandler();
  }
}

DOMReady( function(){
  let contentmask = new ContentMask();
  contentmask.init();
});